import { Component, Output, Input, EventEmitter, OnInit, AfterViewInit, ViewChild, ElementRef, Inject, OnDestroy } from '@angular/core';
import { NavService } from '../header/nav/nav.service';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Router } from '@angular/router';
import {TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { SharedService } from '../common/shared.service';
import { ISubscription } from 'rxjs/Subscription';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { TopnavService } from '../header/topnav/topnav.service';
import { PortalService } from '../services/portal.service';
import { Http, Response } from '@angular/http';
import { analyzeAndValidateNgModules } from '@angular/compiler';

export interface DialogData {
  type;
  title;
  path;
  desc;
}

/**
 * Author: Noraini A.Ghani
 * 
 * Date Created: December 5th 2019
 * 
 * Description: Component class for Media Gallery - /galleries
 **/
@Component({
  selector: 'gosg-galleries',
  templateUrl: './galleries.component.html',
  styleUrls: ['./galleries.component.css']
})
export class GalleriesComponent implements OnInit {

  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  public subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';

  private typingTimer: any;
  private doneTypingInterval:number = 1200;

  private currentType = 2;
  @Input()
  agencySel: String
  statusID: any;
  subID: number;
  moduleName: string;
  @Output() langChange = new EventEmitter();

  showPopup: boolean;
  isImages:boolean;
  isDocument:boolean;
  isAudio:boolean;
  isVideo:boolean;

  loading = false;
  lang: any;
  langId: any;
  arrImages = [];
  arrVideo = [];
  arrAudio = [];
  arrAgensi = [];

  listPhoto = [];
  listVideo = [];
  listAudio = [];

  flagCP = false;
  flagCA = false;
  flagCV = false;
  clickImg = false
  clickAud = false;
  clickVid = false;
  slideIndex = 1;

  currentyear = new Date().getFullYear();
  listMedia: any;
  imgDefaultVid = 'assets/images/video.png';
  imgDefaultAud = 'assets/images/audio.png';
  imgDefaultImg = 'assets/images/image.png';
  dAudio = 'assets/images/dAudio.mp3';
  dVideo = 'assets/images/dVideo.mp4';
  titleMain = '';
  titleDesc = '';
  codeMain: any;
  mediaId: any;
  mediaPath = '';
  originalFile = '';

  pageSize = 20;
  pageCount = 1;
  noPrevData = true;
  noNextData = false;
  listData: any;
  listDataI: any;
  listDataA: any;
  listDataV: any;
  idMedia: any;
  lengthI = 0;
  lengthA = 0;
  lengthV = 0;

  private subscriptionLang: ISubscription;

  constructor(
    private navService: NavService,
    private translate: TranslateService,
    private router: Router,
    private sharedService: SharedService,
    @Inject(APP_CONFIG) private config: AppConfig,
    private topnavservice: TopnavService,
    private portalService:PortalService,
    private http: Http,
    public dialog: MatDialog
  ) {

    this.lang = this.translate.currentLang;
    this.subscriptionLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      const myLang = translate.currentLang;

      if (myLang == 'en') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'en';
          this.langId = 1;
          this.moduleName = this.router.url.split('/')[1];
        });
      }
      if (myLang == 'ms') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'ms';
          this.langId = 2;
          this.moduleName = this.router.url.split('/')[1];

          this.subID = parseInt(this.router.url.split('/')[3]);
        });
      }

      if(this.topnavservice.flagLangAppMngmnt){
        this.moduleName = this.router.url.split('/')[1];
        // this.navService.triggerGalleries(this.langId, this.currentType);

        this.showPopup = false;
        this.isImages = false;
        this.isAudio = false;
        this.isDocument = false;
        this.isVideo = false;
        this.getListMedia();
        this.getMediaAgency();

        if(this.flagCP == true || this.flagCA == true || this.flagCV == true){
          let x = document.getElementsByClassName('loopImg');    
          $(x).css('display','none');
          this.flagCP = false;
          this.flagCA = false;
          this.flagCV = false;
          this.clickImg = true;
          this.clickAud = true;
          this.clickVid = true;
          // this.currentSlide(this.slideIndex,this.mediaId);
          // this.clickChildMedia(this.mediaPath,undefined,this.mediaId, '', this.slideIndex-1);
          console.log("Tukar Lang Slider ");
          console.log(this.clickImg, ": ", this.clickAud, ' : ', this.clickVid);
        }

        if(this.clickImg == true || this.clickAud == true || this.clickVid == true){
          console.log("Tukar Lang Child");
          this.getLoopMedia(this.pageCount, this.pageSize, this.mediaId, this.codeMain);
        }
      }

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string) => {
          title = title + this.translate.instant('home.breadcrumb.gallery');
          this.sharedService.setTitle(title);
        }); 
      },500);
    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
      this.fontType = data;
    });
  }

  ngOnInit() {
    if (!this.langId) {
      if (localStorage.getItem('langID')) {
        this.langId = localStorage.getItem('langID');
      } else { 
        this.langId = 1;
      }
    }

    this.getListMedia();
    this.getMediaAgency();
  }

  ngAfterViewInit() {
      
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = title + this.translate.instant('home.breadcrumb.gallery');
      this.sharedService.setTitleAndGtag(title);
    });
    
    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();
  }

  getTheme(){
    return localStorage.getItem('themeColor');
  }

  clickTab(e?){
    console.log(e);
    let textTab = '';

    setTimeout(()=>{
      if(e){ // onclick tab
        console.log(e.tab.textLabel);
        textTab = e.tab.textLabel;
        for (let i = 0; i < this.listMedia.length; i++) {
          if(this.listMedia[i].name == textTab && this.listMedia[i].id !=5){
            if(this.listMedia[i].id == 2){
              // this.listData = this.listDataI;
              this.idMedia = this.listMedia[i].id;
              console.log('**A**');
            }
            else if(this.listMedia[i].id == 3){
              // this.listData = this.listDataA;
              this.idMedia = this.listMedia[i].id;
              console.log('**B**');
            }
            else if(this.listMedia[i].id == 4){
              // this.listData = this.listDataV;
              this.idMedia = this.listMedia[i].id;
              console.log('**C**');
            }
            this.getLoopMedia(this.pageCount, this.pageSize, this.idMedia);
          }
        }
      }
      
      // else{
      //   this.listData = this.listDataI;   //photo list   
      //   console.log('**D**');
      // }

    },800); 
    
    let x = document.getElementsByClassName('loopImg');    
    $(x).css('display','none');
    let y = document.getElementsByClassName('loopImg2');    
    $(y).css('display','none');

    this.clickImg = false;
    this.clickAud = false;
    this.clickVid = false;
    this.flagCP = false;
    this.flagCA = false;
    this.flagCV = false;
  }

  getLoopMedia(page, size, id, code?){
    this.loading = true;

    return this.http.get(this.config.urlPortal + 'galleryNew?language=' + this.langId + '&mediaTypeId='+id+'&page='+page+'&size='+size+'&sort=startDate,desc')
    // return this.http.get(this.config.urlPortal + 'galleryNew?language=' + this.langId + '&mediaTypeId='+id+'&page='+this.pageCount+'&size=99&sort=startDate,desc')
    .map((response: Response) => response.json()).subscribe(
    data => {
      
      if(id == 2){
        this.arrImages = data['list'];
        this.listDataI = data;
        this.listData = this.listDataI;
        this.lengthI = this.listDataI.totalElements;
        
        if(code){
          for (let i = 0; i < this.arrImages.length; i++) {
            if(this.arrImages[i].code == code){
              this.titleMain = this.arrImages[i].title;
              this.titleDesc = this.arrImages[i].description;
            }
          }
        }
      }
      if(id == 3){
        this.arrAudio = data['list'];
        this.listDataA = data;
        this.listData = this.listDataA;
        this.lengthA = this.listDataA.totalElements;

        if(code){
          for (let i = 0; i < this.arrAudio.length; i++) {
            if(this.arrAudio[i].code == code){
              this.titleMain = this.arrAudio[i].title;
              this.titleDesc = this.arrAudio[i].description;
            }
          }
        }
      }
      if(id == 4){
        this.arrVideo = data['list'];
        this.listDataV = data;
        this.listData = this.listDataV;
        this.lengthV = this.listDataV.totalElements;

        if(code){
          for (let i = 0; i < this.arrVideo.length; i++) {
            if(this.arrVideo[i].code == code){
              this.titleMain = this.arrVideo[i].title;
              this.titleDesc = this.arrVideo[i].description;
            }
          }
        }
      }        

      if (this.listData.pageNumber == this.listData.totalPages || this.listData.totalPages == 0)  {
        this.noNextData = true;
        if (this.listData.totalPages == 1 || this.listData.totalPages == 0) {
          this.noPrevData = true;
        }
      } 
      else {
        this.noNextData = false
        if (this.listData.totalPages == 1 || this.listData.totalPages == 0) {
          this.noPrevData = true;
        }
      }
      this.loading = false;
    });
  }

  // Get details images, audio, video
  getListIAV(code, mediaId){
    this.loading = true;

    return this.http.get(this.config.urlPortal + 'galleryNew/files/'+code+'?language=' + this.langId + '&mediaTypeId='+mediaId+'&page=1&size=50&sort=galleryCode,asc')
    .map((response: Response) => response.json()).subscribe(
    data => {
      
      if(mediaId == 2){ // Images
        this.listPhoto = data['list'];
        this.loading = false;
      }

      else if(mediaId == 3){ // Audio
        this.listAudio = data['list'];
        this.loading = false;
      }

      else if(mediaId == 4){ // Video
        this.listVideo = data['list'];
        this.loading = false;
      }

      else if(mediaId == 5){ // Agensi
      }
      
    });
  }

  getMediaAgency(){
    this.loading = true;

    return this.http.get(this.config.urlGallery + '?language=' + this.langId+ '&id=5')
    .map((response: Response) => response.json()).subscribe(
    data => {
      
      this.arrAgensi = data['list'];   
      this.loading = false;
    });
  }

  getListMedia(){
    this.loading = true;

    return this.http.get(this.config.urlPortal + 'galleryNew/mediaType?language=' + this.langId)
    .map((response: Response) => response.json()).subscribe(
    data => {
      
      this.listMedia = data['list'];
      let tempArr = [];

      for (let i = 0; i < this.listMedia.length; i++) {
        if(this.listMedia[i].id != 1 && this.listMedia[i].id != 5){
          this.getLoopMedia(this.pageCount, this.pageSize, this.listMedia[i].id);
        }
        if(this.listMedia[i].id == 2){
          tempArr.push({"id":this.listMedia[i].id, "name":this.listMedia[i].name, "icon": "fa fa-image"});
        }

        if(this.listMedia[i].id == 3){
          tempArr.push({"id":this.listMedia[i].id, "name":this.listMedia[i].name, "icon": "fa fa-file-audio-o"});
        }

        if(this.listMedia[i].id == 4){
          tempArr.push({"id":this.listMedia[i].id, "name":this.listMedia[i].name, "icon": "fa fa-file-video-o"});
        }

        if(this.listMedia[i].id == 5){
          tempArr.push({"id":this.listMedia[i].id, "name":this.listMedia[i].name, "icon": "fa fa-users"});
        }
      }
      this.listMedia = tempArr;
      console.log(this.listMedia);      
      this.loading = false;
    });
  }

  plusSlides(n, mid) {
    this.showSlides(this.slideIndex += n, mid);
  }

  currentSlide(n, mid) {
    this.showSlides(this.slideIndex = n, mid);
  }

  showSlides(n, mid) {
    console.log("======================Start Show===================");
    this.loading = true;
    var slides = document.getElementsByClassName("mySlides");
    var dots = document.getElementsByClassName("dot");
     
    for (let i = 0; i < slides.length; i++) {
      $(slides[i]).css('display', 'none');
    }

    for (let i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }

    let a = this.slideIndex-1;

    //===================== original =======================
    // if(a == this.listPhoto.length){
    //   this.slideIndex = 1;
    // }
    // if(a == -1){
    //   this.slideIndex = this.listPhoto.length;
    // } 
    //===================== end original ===================

    
    //===================== new ============================

    let tempListMedia = [];
    if(mid == 2){
      tempListMedia = this.listPhoto;
    }
    else if(mid == 3){
      tempListMedia = this.listAudio;
    }
    else if(mid == 4){
      tempListMedia = this.listVideo;
    }
    
    if(a == tempListMedia.length){
      this.slideIndex = 1;
    }
    if(a == -1){
      this.slideIndex = tempListMedia.length;
    } 
    //===================== end new ========================

   
    $(slides[this.slideIndex-1]).css('display', 'block');
    dots[this.slideIndex-1].className += " active";
    
    let changePath = '';
    console.log("Click pic NO : ", n);
    console.log("this.slideIndex : ", this.slideIndex);

    //===================== original =======================
    // for (let i = 0; i < this.listPhoto.length; i++) {
    
    //   if(i+1 == n){
    //     changePath = this.listPhoto[i].mediaFile;
    //   }
    //   else if(n > this.listPhoto.length){
    //     changePath = this.listPhoto[0].mediaFile;
    //   }
    //   else if(n == 0){
    //     changePath = this.listPhoto[this.listPhoto.length-1].mediaFile;
    //   }
    // }
    // slides[this.slideIndex-1].getElementsByTagName('img')[0].src = this.config.externalMediaURL2+changePath.substr(1);  
    //===================== end original ===================


    //===================== new ============================
    for (let i = 0; i < tempListMedia.length; i++) {
    
      if(i+1 == n){
        changePath = tempListMedia[i].mediaFile;
      }
      else if(n > tempListMedia.length){
        changePath = tempListMedia[0].mediaFile;
      }
      else if(n == 0){
        changePath = tempListMedia[tempListMedia.length-1].mediaFile;
      }
    }

    console.log("mid: ", mid);
    if(mid == 2){
      slides[this.slideIndex-1].getElementsByTagName('img')[0].src = this.config.externalMediaURL2+changePath.substr(1); 
    }
    else if(mid == 3){
      console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
      for (let i = 0; i < slides.length; i++) {
        console.log("ini audio");
        slides[i].getElementsByTagName('audio')[0].pause();
      }
      slides[this.slideIndex-1].getElementsByTagName('audio')[0].src = this.config.externalMediaURL2+changePath.substr(1); 
      slides[this.slideIndex-1].getElementsByTagName('audio')[0].play();
    }
    else if(mid == 4){
      console.log("vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
      for (let i = 0; i < slides.length; i++) {
        console.log("ini video");
        slides[i].getElementsByTagName('video')[0].pause();
      }
      slides[this.slideIndex-1].getElementsByTagName('video')[0].src = this.config.externalMediaURL2+changePath.substr(1); 
      slides[this.slideIndex-1].getElementsByTagName('video')[0].play();
    }    
    //===================== end new ========================

    let x = document.getElementsByClassName('loopImg');    
    $(x).css('display','block');
    let y = document.getElementsByClassName('loopImg2');    
    $(y).css('display','inline');
    this.loading = false;
  }

  clickImage(val, valClick, ind, code, idMedia, title?, desc?){
    console.log(val, valClick, ind, code, idMedia, title, desc)
    if(idMedia == 2){
      this.clickImg = valClick;
    }
    if(idMedia == 3){
      this.clickAud = valClick;
    }
    if(idMedia == 4){
      this.clickVid = valClick;
    }
    this.codeMain = code;
    this.mediaId = idMedia;
    this.titleMain = title;
    this.titleDesc = desc;
    
    this.getListIAV(code, idMedia);
  }

  clickChildMedia(path,parentFlag,mediaId, titleOri, ind){
    this.mediaPath = path;
    this.originalFile = titleOri;
    this.clickImg = parentFlag;
    this.clickAud = parentFlag;
    this.clickVid = parentFlag;

    this.slideIndex = ind + 1; 
    this.currentSlide(this.slideIndex,mediaId);

    if(mediaId == 2){
      this.flagCP = true;
      // this.slideIndex = ind + 1; 
      // this.currentSlide(this.slideIndex,mediaId);
    }
    else if(mediaId == 3){
      this.flagCA = true;
    }
    else if(mediaId == 4){
      this.flagCV = true;
    }

    // let positionScreen = $('.bgSreenImg').position();
    // console.log("POSITION SCREEN: ", positionScreen);
    // console.log($(window).height());
    $(window).scrollTop(145);
  }

  closeToMain(mID, close){

    if(mID == 2){
      this.clickImg = close;
    }
    else if(mID == 3){
      this.clickAud = close;
    }
    else if(mID == 4){
      this.clickVid = close;
    }
    else if(mID == 5){
    }
  }

  // Show chlids landing tab.
  closeDetailChild(flag, mID, ind?){

    let x = document.getElementsByClassName('loopImg');    
    $(x).css('display','none');
    let y = document.getElementsByClassName('loopImg2');    
    $(y).css('display','none');
    var slides = document.getElementsByClassName("mySlides");

    console.log("ind ", ind);

    if(mID == 2){
      // let x = document.getElementsByClassName('loopImg');    
      // $(x).css('display','none');
      // let y = document.getElementsByClassName('loopImg2');    
      // $(y).css('display','none');
      this.flagCP = flag;
      this.clickImg = true;
    }
    else if(mID == 3){
      this.flagCA = flag;
      this.clickAud = true;
      slides[ind].getElementsByTagName('audio')[0].pause();
    }
    else if(mID == 4){
      this.flagCV = flag;
      this.clickVid = true;
      slides[ind].getElementsByTagName('video')[0].pause();
    }
  }

  pageChange(event){
    window.scrollTo(0, 0);
    console.log("-------Page Change------------");
    this.getLoopMedia(this.pageCount, event.value, this.idMedia);
    this.pageSize = event.value;  
  }

  paginatorL1(page){

    console.log("-----LEFT <<------------");
    this.getLoopMedia(1, this.pageSize, this.idMedia);
    this.noPrevData = true; //page <= 2 ? true : false;
    this.noNextData = false;
    window.scrollTo(0, 0);
  }

  paginatorL(page){
    console.log("-----LEFT ------------");
    this.getLoopMedia(page-1, this.pageSize, this.idMedia);
    this.noPrevData = page <= 2 ? true : false;
    this.noNextData = false;
    window.scrollTo(0, 0);
  }

  paginatorR(page, totalPages){
    console.log("-----RIGHT------------");
    this.noPrevData = page >= 1 ? false : true;
    let pageInc = page+1;
    // this.noNextData = pageInc === totalPages;
    this.getLoopMedia(page+1, this.pageSize, this.idMedia);
    window.scrollTo(0, 0);
  }

  paginatorRL(page, totalPages){
    this.noPrevData = page >= 1 ? false : true;
    let pageInc = totalPages;
    this.noNextData = pageInc === totalPages;
    console.log("-----RIGHT >>------------");
    this.getLoopMedia(totalPages, this.pageSize, this.idMedia);
    window.scrollTo(0, 0);
  }

  downloadFile(filePath) {
    window.open(filePath);
  }

  getThemeF() {
    return localStorage.getItem('themeColor');
  }

}



// WEBPACK FOOTER //
// ./src/app/galleries/galleries.component.ts